import { derived } from "svelte/store";
import { useQuery } from "@sveltestack/svelte-query";

/**
 * Query available languages
 * @returns {Readable<{[lang: string]: string}|undefined>}
 */
export function useAvailableLanguages() {
  const query = useQuery("/api/locales/available")
  return derived(query, query => query?.data?.locales)
}
